import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { DENSITY } from '@savgroup-front-common/core/atoms/VerticalOneColumnLayout/VerticalOneColumnLayout.types';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { customerState } from '../../../../domains/Customer/selectors';
import { useMyAccountTypedSelector } from '../../../../hooks';
import { useLayout } from '../../../app/NewLayout/NewLayout.hooks';
import FileDocuments from '../../../components/FileDocuments/FileDocuments';
import { FileHistory } from '../../../components/FileHistory';
import { ProductsInfo } from '../../../components/ProductsInfo';
import {
  useFileFollowupsPage,
  useGetProductsDetails,
} from '../FileFollowupsPage.hooks';
import { $LayoutGrid } from '../FileFollowupsPage.styles';
import { useGetCustomerFileFullSummaryQuery } from '../hooks/useGetCustomerFileFullSummaryQuery';

import ClaimsSummary from './ClaimsSummary/ClaimsSummary';
import ExpectsContainer from './ClientAction/ExpectsContainer/ExpectsContainer';
import FileFollowupsContext from './FileFollowups.context';
import TrackingInfo from './TrackingInfo/TrackingInfo';

const FileFollowups: FC = () => {
  const { fileId } = useParams() as { fileId: string };
  const { histories, fullClaim, isLoadingHistories, isLoadingFullClaim } =
    useFileFollowupsPage();
  const { fileInfo, isLoading: isLoadingFileSummary } =
    useGetCustomerFileFullSummaryQuery({ fileId });
  const { productsDetails, isLoadingSolution, isLoadingModel } =
    useGetProductsDetails();

  const isLoading =
    fileId !== fileInfo?.fileId ||
    isLoadingFileSummary ||
    isLoadingModel ||
    isLoadingSolution ||
    isLoadingHistories ||
    isLoadingFullClaim;

  const customer = useMyAccountTypedSelector(customerState);
  const { bannerUrl } = useLayout();

  if (isLoading || !customer || !customer?.customerFileSummary || !fileInfo) {
    return <BaseLoader />;
  }

  return (
    <FileFollowupsContext.Provider
      value={{ fileSummary: customer?.customerFileSummary }}
    >
      <$LayoutGrid
        $hasBanner={!!bannerUrl}
        density={DENSITY.COMFORTABLE}
        isFluid
      >
        <ProductsInfo
          fileInfo={fileInfo}
          productsInfo={productsDetails}
          histories={histories}
        />

        <ClaimsSummary fileInfo={fileInfo} fileStatus={histories?.at(0)} />

        <ExpectsContainer />

        <TrackingInfo fileInfo={fileInfo} />

        {fullClaim && <FileDocuments fullClaim={fullClaim} />}

        <FileHistory histories={histories} />
      </$LayoutGrid>
    </FileFollowupsContext.Provider>
  );
};

export default React.memo(FileFollowups);
